import api from "./axios";

// ── Self-service (admins + employees) ──────────────────────────────────────
export const myLeaveBalances = (year) => api.get("/my/leaves/balances", { params: { year } });
export const myLeaves = (params = {}) => api.get("/my/leaves", { params });
export const applyLeave = (payload) => api.post("/my/leaves", payload);
export const cancelMyLeave = (id) => api.patch(`/my/leaves/${id}/cancel`);

// ── Admin: types / balances / workflow ─────────────────────────────────────
export const listLeaveTypes = () => api.get("/leave-types");
export const createLeaveType = (payload) => api.post("/leave-types", payload);
export const updateLeaveType = (id, payload) => api.put(`/leave-types/${id}`, payload);
export const deleteLeaveType = (id) => api.delete(`/leave-types/${id}`);

export const listLeaveBalances = (params = {}) => api.get("/leave-balances", { params });
export const updateLeaveBalance = (id, allocatedDays) =>
  api.put(`/leave-balances/${id}`, { allocated_days: allocatedDays });

export const listLeaves = (params = {}) => api.get("/leaves", { params });
export const approveLeave = (id, note) => api.patch(`/leaves/${id}/approve`, { note });
export const rejectLeave = (id, note) => api.patch(`/leaves/${id}/reject`, { note });
export const adminCancelLeave = (id, note) => api.patch(`/leaves/${id}/cancel`, { note });
